export { default as I18nProvider } from "./I18nProvider";
export { default as useI18n } from "./useI18n";
export { default as withI18n } from "./withI18n";

import { InjectedI18nProps as TInjectedI18nProps } from "./withI18n";
export type InjectedI18nProps = TInjectedI18nProps;

import { MessagesType as TMessagesType } from "./types";
export type MessagesType = TMessagesType;
